<div class="mb-5 mr-5 ml-5 scrollable-content">
  <ul>
    @for (policy of policyUsage; track policy.policyId) {
      <li>
        @if (editDisabled) {
          Policy: {{ policy.policyName }}
        } @else {
          Policy: <a [href]="getPolicyLink(policy)" target="_blank">{{ policy.policyName }}</a>
        }
      </li>
    }
    @for (profile of profileUsage; track profile.profileId) {
      <li>
        @if (editDisabled) {
          Profile: {{ profile.profileName }}
        } @else {
          Profile: <a [href]="getProfileLink(profile)" target="_blank">{{ profile.profileName }}</a>
        }
      </li>
    }
    @for (di of diUsage; track di.dataIdentifierId) {
      <li>
        @if (editDisabled) {
          Data Identifier: {{ di.dataIdentifierName }}
        } @else {
          Data Identifier: <a [href]="getDiLink(di)" target="_blank">{{ di.dataIdentifierName }}</a>
        }
      </li>
    }
    @for (ptrn of patternUsage; track ptrn.patternId) {
      <li>
        <ng-container>Pattern: {{ ptrn.patternId }}</ng-container>
      </li>
    }
    @for (response of responseUsage; track response.patternId) {
      <li>
        @if (editDisabled) {
          Response: {{ response.patternName }}
        } @else {
          Response:
          <a [href]="getResponseLink(response)" target="_blank">{{ response.patternName }}</a>
        }
      </li>
    }
  </ul>
</div>
<div class="ui-dialog-footer">
  <button symButton type="button" label="Cancel" aria-label="Cancel" (click)="onCancel()"></button>
</div>
